import React, { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import FlexView from "react-flexview";
import { useDispatch, useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import ErrorAction from "../../Redux/ErrorRedux";
import SimpleModal from "../popup/SimpleModal";
import ModalContainer from "./ModalContainer";

export default function ErrorAlert() {
  const [copyText, setCopyText] = useState("Copy");
  const dispatch = useDispatch();
  const { code, menuName, errorMessage } = useSelector((state) => state.error);

  return (
    <>
      {errorMessage ? (
        <SimpleModal
          title={menuName || code}
          visible={!!errorMessage}
          styles={{ width: "700px" }}
          onClickClose={() => dispatch(ErrorAction.clearError())}
          content={
            <div style={{ padding: "16px 15px" }}>
              {menuName ? (
                <>
                  <h3>Gagal Melakukan Proses</h3>
                  <FlexView vAlignContent="center">
                    <p>Error Code: {errorMessage}</p>
                    <CopyToClipboard text={errorMessage} onCopy={() => setCopyText("Copied")}>
                      <button
                        className="margin-left-10px"
                        style={{ background: "unset", cursor: "pointer" }}
                        data-tip={copyText}
                        data-for="copyToClipboard"
                        onMouseLeave={() => setCopyText("Copy")}
                      >
                        <i className="fa fa-clipboard"></i>
                      </button>
                    </CopyToClipboard>
                    <ReactTooltip id="copyToClipboard">{copyText}</ReactTooltip>
                  </FlexView>
                </>
              ) : (
                <p>{errorMessage}</p>
              )}
            </div>
          }
        />
      ) : null}
    </>
  );
}
